import React from 'react';
import PropTypes from 'prop-types';
import PageTitle from '../../components/pageTitle';
import Input from './input';
import InputFile from '../../components/inputFile';
import Select from '../../components/form/select';
import SocialAuth from '../../components/socialAuth';
import './styles.css';
import CheckBox from '../../components/checkBox';

const Profile = ({
  t,
  langs,
  errors,
  goBack,
  checked,
  onChange,
  formData,
  onSubmit,
  avatarSrc,
  emailTokens,
  isSubmitting,
  updateChecked,
  backgroundColor,
}) => (
  <section className="customerSetting boxs mt2rem">
    <PageTitle
      title={t('Profile')}
      backgroundPage={backgroundColor}
      enableCoverColor={1}
    />
    <div className="container">
      <div className="leftinner boxs">
        <ul className="goback">
          <li><a href="#prev" onClick={() => goBack()}><i className="fa fa-angle-left" aria-hidden="true" />{t('Go back to previous page')}</a></li>
        </ul>
      </div>
      <form onSubmit={onSubmit}>
        <div className="csettinginner boxs">
          <div className="topdiv boxs" id="profile">
            <div className="leftdiv">
              <div className="leftinner boxs">
                <ul className="applinks">
                  <li>{t('Your profile')}</li>
                </ul>
              </div>
            </div>
            <div className="rightdiv">
              <div className="rightinner boxs">
                <div className="setformwd setformwd50 mglft">
                  <div className="boxs height100">
                    <div className="boxs inputset_outer height100">
                      <div className="inputsetting boxs height100">
                        <InputFile id="avatar" >
                          <div className={`yeslogo yeslogophoto yeslogo2 ${avatarSrc ? 'active' : ''}`}>
                            <span className="nologo nophoto">{t('No photo')}</span>
                            <span className="btn_upload uploadnew btn_upload1 btn_uploadposi">
                              {t('Upload new?')}
                            </span>
                            {avatarSrc && (<img id="ImgPreview4" src={avatarSrc} className="preview4 img-responsive" alt="" />)}
                          </div>
                        </InputFile>
                        <div className="social-auth">
                          <SocialAuth signs={formData.socials} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="setformwd setformwd50 mgryt">
                  <div className="boxs">
                    <Input
                      name="first_name"
                      errors={errors}
                      label={t('Your first name')}
                      onChange={onChange}
                      value={formData.first_name}
                      tabindex="1"
                    />
                    <Input
                      name="email"
                      errors={errors}
                      label={t('Your e-mail')}
                      onChange={onChange}
                      value={formData.email}
                      tabindex="3"
                    />
                    <Input
                      name="password"
                      type="password"
                      placeholder="****"
                      errors={errors}
                      autoComplete="new-password"
                      label={t('New password')}
                      onChange={onChange}
                      value={formData.password}
                      tabindex="5"
                    />
                      <Input
                        name="company_name"
                        placeholder={t('Company name')}
                        label={t('Company name')}
                        onChange={onChange}
                        errors={errors}
                        value={formData.company_name}
                        tabindex="7"
                      />
                  </div>
                </div>
                <div className="setformwd setformwd50 mgryt" style={{ marginBottom: '7rem' }}>
                  <div className="boxs">
                    <Input
                      name="last_name"
                      errors={errors}
                      label={t('Your last name')}
                      onChange={onChange}
                      value={formData.last_name}
                      tabindex="2"
                    />
                    <Input
                      name="phone"
                      errors={errors}
                      label={t('Your phone')}
                      onChange={onChange}
                      value={formData.phone}
                      tabindex="4"
                      type="phone"
                    />
                    <Input
                      name="repeat"
                      type="password"
                      placeholder="****"
                      errors={errors}
                      label={t('Repeat new password')}
                      autoComplete="new-password"
                      onChange={onChange}
                      value={formData.repeat}
                      tabindex="6"
                    />
                    <div className="boxs inputset_outer">
                      <div className="inputsetting boxs">
                        <Select
                          name="language"
                          errors={errors}
                          label={t('Select language')}
                          placeholder={t('Select language')}
                          onChange={onChange}
                          value={formData.language}
                          options={langs}
                          empty="Default"
                          tabindex="8"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bottomdiv boxs" id="notifications">
            <div className="leftdiv">
              <div className="leftinner boxs">
                <ul className="applinks">
                  <li>{t('Notifications')}</li>
                </ul>
              </div>
            </div>
            <div className="rightdiv">
              <div className="rightinner boxs">
                <div className="boxs">
                  <div className="boxs height100">
                    <div className="boxs inputset_outer height100">
                      <div className="inputsetting boxs height100">
                        <div className="em-token">
                          <div className="em-left" />
                          <img
                            src="./img/email.svg"
                            alt="email"
                            height="40px"
                            className="em-right"
                          />
                        </div>

                        {formData.emailPermissions.map(perm => (
                          <div key={perm.type} className="em-token">
                            <label for={`em_${perm.type}`}><h5 key={perm.type} className="em-left">{emailTokens[perm.type]}</h5></label>
                            <div className="em-right">
                              <CheckBox
                                index={perm.type}
                                updateChecked={updateChecked}
                                checked={checked[perm.type]}
                              />
                            </div>
                          </div>
                        ))}
                        <div className="boxs surveybtn feedbacksurvey pr-save">
                          <div className="boxs">
                            <div className="left" />
                            <div className="right">
                              <span>
                                <button disabled={isSubmitting} type="submit" className="next nextgray btnpurple">{t('Save')}</button>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
);

Profile.propTypes = {
  t: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default Profile;



// WEBPACK FOOTER //
// ./src/views/profile/Profile.jsx